<template>
  <v-alert
    :type="alert.type"
    v-model="alert.show"
    class="mb-5"
    :dismissible="alert.dismissible"
    transition="fade-transition"
  >
    {{ alert.message }}
  </v-alert>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Alert',
  computed: mapGetters(['alert']),
}
</script>
